import Text from '../../../../Text'
import { ApplicantProfileWidgetStageScreeningRow } from '../ApplicantProfileWidgetStageScreeningRow'

import * as styles from './ApplicantProfileWidgetStageScreeningGroup.module.css'

function ApplicantProfileWidgetStageScreeningGroup({ checks, title }) {
  return (
    <div className={styles.ApplicantProfileWidgetStageScreeningGroup}>
      <Text isSecondary className={styles.title}>
        {title}
      </Text>
      <div className={styles.checks}>
        {checks.map(({ key, ...check }) => (
          <ApplicantProfileWidgetStageScreeningRow {...check} key={key} />
        ))}
      </div>
    </div>
  )
}

export default ApplicantProfileWidgetStageScreeningGroup
